import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const InstalledBaseNodeAttributeListTDAs = gql`
    query InstalledBaseNodeAttributeListTDAs($typeDefinitionIndex: PropertyDefinitionTypeDefinitionIndex!, $options: InstalledBasePropertyDefinitionTypeDefinitionAttributeListOptionsInput) {
        installedBaseNodePropertyDefinitionList {
            typeDefinitionAttributeList(typeDefinitionIndex: $typeDefinitionIndex, options: $options) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
